<template>
  <div id="app" class="container" :class="[sidebarHidden ? 'sidebar-hidden' : '']">
    <div class="sidebar">
      <side-menu></side-menu>
    </div>
    <div class="topbar">
      <el-button type="text" @click="sidebarHidden = !sidebarHidden">
        <i class="fa fa-bars" aria-hidden="true"></i>
      </el-button>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import SideMenu from './SideMenu'

export default {
  data () {
    return {
      sidebarHidden: false
    }
  },
  components: {
    SideMenu
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/mixins';

$sidebar-width: 210px;
$topbar-height: 56px;
$sidebar-transition: .3s cubic-bezier(.25,.8,.25,1);
$light-black-color: #324057; // dark theme

.container {
  @include clearfix;
  position: relative;
  width: 100%;
  height: 100%;

  &.sidebar-hidden {

    .sidebar {
      transform: translate(-$sidebar-width, 0);
    }

    .main {
      left: 0;
    }

    .topbar {
      left: 0;
    }
  }

  .sidebar {
    width: $sidebar-width;
    position: fixed;
    min-height: 100%;
    border-right: solid 1px #e6e6e6;
    transition: $sidebar-transition;
    z-index: 3;
    top: 0;
  }

  .topbar {
    height: $topbar-height;
    padding: 0 10px;
    position: fixed;
    z-index: 2;
    top: 0;
    right: 0;
    left: $sidebar-width;
    background: #EFF2F7;
    transition: $sidebar-transition;

    & > button:first-child {
      font-size: 28px;
      color: $light-black-color;

      &:hover {
        color: lighten($light-black-color, 15);
      }
    }

    & > * {
      line-height: $topbar-height;
      padding: 0;
    }
  }

  .main {
    transition: $sidebar-transition;
    position: absolute;
    top: $topbar-height;
    bottom: 0;
    right: 0;
    left: $sidebar-width;
    z-index: 1;

    .el-card {
      margin: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue